__turbopack_context__.v({
  "controls": "video-layout-module__WOKBva__controls",
});
